import { ReactNode, createContext, useState, useContext } from "react";
import { IAuth, IUsuarios } from "../models";

type UsuarioProviderProps = {
  children: ReactNode;
};

type UsuarioContext = {
  usuario: IUsuarios;
  autenticado: IAuth;
  statusBatalhando: boolean;
  statusTreinoInicial: boolean;
  setUsuarioCorrente: (valor: IUsuarios) => void;
  setUsuarioAutenticado: (valor: IAuth) => void;
};

export const AppContext = createContext({} as UsuarioContext);

export function AppProvider({ children }: UsuarioProviderProps) {
  const [usuario, setUsuario] = useState({} as IUsuarios);
  const [autenticado, setAutenticado] = useState({} as IAuth);
  const [statusBatalhando, setStatusBatalhando] = useState(false);
  const [statusTreinoInicial, setTreinoInicial] = useState(true);

  const setUsuarioCorrente = (valor: IUsuarios) => {
    setUsuario(valor);
    setStatusBatalhando(valor?.system?.in_combat);
    setTreinoInicial(valor?.system?.tutorial_begin);
  };

  const setUsuarioAutenticado = (valor: IAuth) => {
    setAutenticado(valor);
  };

  return (
    <AppContext.Provider
      value={{
        usuario,
        autenticado,
        setUsuarioCorrente,
        setUsuarioAutenticado,
        statusBatalhando,
        statusTreinoInicial,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => {
  return useContext(AppContext);
};
